import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthProvider } from './hooks/useAuth';
import { ToastProvider, useToast } from './contexts/ToastContext';
import { ToastContainer } from './components/ToastContainer';
import { initializeApi } from './services/api';
import { initializeApiHelpers } from './utils/apiHelpers';
import PrivateRoute from './components/PrivateRoute';

// Pages
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import StoryEditor from './pages/StoryEditor';
import Settings from './pages/Settings';
import PublicStory from './pages/PublicStory';
import "react-quill-new/dist/quill.snow.css";

function AppContent() {
  const { error, success } = useToast();
  
  useEffect(() => {
    // Initialize API with toast functions
    initializeApi(error);
    initializeApiHelpers(success);
  }, [error, success]);

  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/stories/public/:publicToken" element={<PublicStory />} />

        {/* Private routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/stories/new"
          element={
            <PrivateRoute>
              <StoryEditor />
            </PrivateRoute>
          }
        />
        <Route
          path="/stories/:id/edit"
          element={
            <PrivateRoute>
              <StoryEditor />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />

        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      <ToastContainer />
    </AuthProvider>
  );
}

function App() {
  return (
    <Router>
      <ToastProvider>
        <AppContent />
      </ToastProvider>
    </Router>
  );
}

export default App;